import { render, staticRenderFns } from "./last.vue?vue&type=template&id=fb78c238&scoped=true&"
import script from "./last.vue?vue&type=script&lang=js&"
export * from "./last.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb78c238",
  null
  
)

export default component.exports